import { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { TableCell, TableRow } from '@digdir/designsystemet-react';

import { OppvarmingVarmepumpe } from '../../../../../../types/registration/userInput';
import {
  AccentedTableRow,
  Capitalize,
  LeftBorderCell
} from '../../../../../expertRegistration/json/enhet/upload/fileReview/components/styledComponents';

interface OppvarmingVarmepumpeProps {
  varmepumpe: OppvarmingVarmepumpe | undefined;
}
export const OppvarmingVarmepumpeView: FC<OppvarmingVarmepumpeProps> = ({ varmepumpe }) => {
  const { t } = useTranslation('', { keyPrefix: 'expertToolsJSON.summary.tekniskutstyr.oppvarming.varmepumpe' });
  const { t: tCommon } = useTranslation('', { keyPrefix: 'expertToolsJSON.summary.common' });

  return (
    varmepumpe && (
      <Fragment>
        <AccentedTableRow $isSecondarySection>
          <TableCell colSpan={2}>{t('header')}</TableCell>
        </AccentedTableRow>
        {varmepumpe.varmeKilde && (
          <TableRow>
            <TableCell>{t('varmekilde.label')}</TableCell>
            <LeftBorderCell>{t(`varmekilde.${varmepumpe.varmeKilde}`)}</LeftBorderCell>
          </TableRow>
        )}

        {varmepumpe.brukStandardVerdier && (
          <TableRow>
            <TableCell>{t('standardverdier.label')}</TableCell>
            <LeftBorderCell>
              {varmepumpe.brukStandardVerdier ? t('standardverdier.yes') : t('standardverdier.no')}
            </LeftBorderCell>
          </TableRow>
        )}

        {varmepumpe.punktoppvarming && (
          <Fragment>
            <AccentedTableRow>
              <TableCell colSpan={2}>{t('punktoppvarming.label')}</TableCell>
            </AccentedTableRow>
            {varmepumpe.punktoppvarming.installasjonsAr && (
              <TableRow>
                <TableCell>{t('punktoppvarming.installasjonsar')}</TableCell>
                <LeftBorderCell>{varmepumpe.punktoppvarming.vetInstallasjonsAr ? varmepumpe.punktoppvarming.installasjonsAr : tCommon('innstallasjonsArUkjent', { byggAr: varmepumpe.punktoppvarming.installasjonsAr })}</LeftBorderCell>
              </TableRow>
            )}
            {varmepumpe.punktoppvarming.serviceGjennomfortSiste2Ar && (
              <TableRow>
                <TableCell>{t('punktoppvarming.serviceGjennomfortSiste2Ar')}</TableCell>
                <LeftBorderCell>
                  {t(`punktoppvarming.${varmepumpe.punktoppvarming.serviceGjennomfortSiste2Ar}`)}
                </LeftBorderCell>
              </TableRow>
            )}
          </Fragment>
        )}

        {varmepumpe.vannbarenVarme && (
          <Fragment>
            <AccentedTableRow>
              <TableCell colSpan={2}>{t('vannbaren.label')}</TableCell>
            </AccentedTableRow>
            {varmepumpe.vannbarenVarme.installasjonsAr && (
              <TableRow>
                <TableCell>{t('vannbaren.installasjonsar')}</TableCell>
                <LeftBorderCell>{varmepumpe.vannbarenVarme.vetInstallasjonsAr ? varmepumpe.vannbarenVarme.installasjonsAr : tCommon('innstallasjonsArUkjent', { byggAr: varmepumpe.vannbarenVarme.installasjonsAr })}</LeftBorderCell>
              </TableRow>
            )}
            {varmepumpe.vannbarenVarme.bruk && (
              <TableRow>
                <TableCell>{t('vannbaren.bruk.label')}</TableCell>
                <LeftBorderCell>{t(`vannbaren.bruk.${varmepumpe.vannbarenVarme.bruk}`)}</LeftBorderCell>
              </TableRow>
            )}
            {varmepumpe.vannbarenVarme.varmesystemBruk && (
              <TableRow>
                <TableCell>{t('vannbaren.varmesystembruk')}</TableCell>
                <LeftBorderCell><Capitalize>{varmepumpe.vannbarenVarme.varmesystemBruk}</Capitalize></LeftBorderCell>
              </TableRow>
            )}
            {varmepumpe.vannbarenVarme.gulvvarme && (
              <TableRow>
                <TableCell>{t('vannbaren.gulvvarme.label')}</TableCell>
                <LeftBorderCell>{t(`vannbaren.gulvvarme.${varmepumpe.vannbarenVarme.gulvvarme}`)}</LeftBorderCell>
              </TableRow>
            )}
            {varmepumpe.vannbarenVarme.radiator && (
              <TableRow>
                <TableCell>{t('vannbaren.radiator.label')}</TableCell>
                <LeftBorderCell>{t(`vannbaren.radiator.${varmepumpe.vannbarenVarme.radiator}`)}</LeftBorderCell>
              </TableRow>
            )}

            {varmepumpe.vannbarenVarme.serviceGjennomfortSiste2Ar && (
              <TableRow>
                <TableCell>{t('vannbaren.serviceGjennomfortSiste2Ar')}</TableCell>
                <LeftBorderCell>
                  {t(`vannbaren.${varmepumpe.vannbarenVarme.serviceGjennomfortSiste2Ar}`)}
                </LeftBorderCell>
              </TableRow>
            )}
          </Fragment>
        )}

        {varmepumpe.vannbarenVarmeMedVarmesentral && (
          <Fragment>
            <AccentedTableRow>
              <TableCell colSpan={2}>{t('vannbarenVarmeMedVarmesentral.label')}</TableCell>
            </AccentedTableRow>
            {varmepumpe.vannbarenVarmeMedVarmesentral.installasjonsAr && (
              <TableRow>
                <TableCell>{t('vannbarenVarmeMedVarmesentral.installasjonsar')}</TableCell>
                <LeftBorderCell>{varmepumpe.vannbarenVarmeMedVarmesentral.vetInstallasjonsAr ? varmepumpe.vannbarenVarmeMedVarmesentral.installasjonsAr : tCommon('innstallasjonsArUkjent', { byggAr: varmepumpe.vannbarenVarmeMedVarmesentral.installasjonsAr })}</LeftBorderCell>
              </TableRow>
            )}
            {varmepumpe.vannbarenVarmeMedVarmesentral.bruk && (
              <TableRow>
                <TableCell>{t('vannbarenVarmeMedVarmesentral.bruk.label')}</TableCell>
                <LeftBorderCell>
                  {t(`vannbarenVarmeMedVarmesentral.bruk.${varmepumpe.vannbarenVarmeMedVarmesentral.bruk}`)}
                </LeftBorderCell>
              </TableRow>
            )}
            {varmepumpe.vannbarenVarmeMedVarmesentral.varmesystemBruk && (
              <TableRow>
                <TableCell>{t('vannbarenVarmeMedVarmesentral.varmesystembruk')}</TableCell>
                <LeftBorderCell><Capitalize>{varmepumpe.vannbarenVarmeMedVarmesentral.varmesystemBruk}</Capitalize></LeftBorderCell>
              </TableRow>
            )}
            {varmepumpe.vannbarenVarmeMedVarmesentral.gulvvarme && (
              <TableRow>
                <TableCell>{t('vannbarenVarmeMedVarmesentral.gulvvarme.label')}</TableCell>
                <LeftBorderCell>
                  {t(`vannbarenVarmeMedVarmesentral.gulvvarme.${varmepumpe.vannbarenVarmeMedVarmesentral.gulvvarme}`)}
                </LeftBorderCell>
              </TableRow>
            )}
            {varmepumpe.vannbarenVarmeMedVarmesentral.radiator && (
              <TableRow>
                <TableCell>{t('vannbarenVarmeMedVarmesentral.radiator.label')}</TableCell>
                <LeftBorderCell>
                  {t(`vannbarenVarmeMedVarmesentral.radiator.${varmepumpe.vannbarenVarmeMedVarmesentral.radiator}`)}
                </LeftBorderCell>
              </TableRow>
            )}
            {varmepumpe.vannbarenVarmeMedVarmesentral.varmesentral && (
                <TableRow>
                  <TableCell>{t('vannbarenVarmeMedVarmesentral.varmesentral.label')}</TableCell>
                  <LeftBorderCell>
                    {t(`vannbarenVarmeMedVarmesentral.varmesentral.${varmepumpe.vannbarenVarmeMedVarmesentral.varmesentral}`)}
                  </LeftBorderCell>
                </TableRow>
              ) &&
              varmepumpe.vannbarenVarmeMedVarmesentral.varmesentralInstallasjonsAr && (
                <TableRow>
                  <TableCell>{t('vannbarenVarmeMedVarmesentral.varmesentral.varmesentralInstallasjonsAr')}</TableCell>
                  <LeftBorderCell>
                    {varmepumpe.vannbarenVarmeMedVarmesentral.vetVarmesentralInstallasjonsAr ? varmepumpe.vannbarenVarmeMedVarmesentral.varmesentralInstallasjonsAr : tCommon('innstallasjonsArUkjent', { byggAr: varmepumpe.vannbarenVarmeMedVarmesentral.varmesentralInstallasjonsAr })}
                  </LeftBorderCell>
                </TableRow>
              )}

            {varmepumpe.vannbarenVarmeMedVarmesentral.serviceGjennomfortSiste2Ar && (
              <TableRow>
                <TableCell>{t('vannbarenVarmeMedVarmesentral.serviceGjennomfortSiste2Ar')}</TableCell>
                <LeftBorderCell>
                  {t(`vannbarenVarmeMedVarmesentral.${varmepumpe.vannbarenVarmeMedVarmesentral.serviceGjennomfortSiste2Ar}`)}
                </LeftBorderCell>
              </TableRow>
            )}
          </Fragment>
        )}
        {varmepumpe.ventilasjon && (
          <Fragment>
            <AccentedTableRow>
              <TableCell colSpan={2}>{t('ventilasjon.header')}</TableCell>
            </AccentedTableRow>
            {varmepumpe.ventilasjon.installasjonsAr && (
              <TableRow>
                <TableCell>{t('ventilasjon.installasjonsar')}</TableCell>
                <LeftBorderCell>{varmepumpe.ventilasjon.vetInstallasjonsAr ? varmepumpe.ventilasjon.installasjonsAr : tCommon('innstallasjonsArUkjent', { byggAr: varmepumpe.ventilasjon.installasjonsAr })}</LeftBorderCell>
              </TableRow>
            )}
            {varmepumpe.ventilasjon.bruk && (
              <TableRow>
                <TableCell>{t('ventilasjon.bruk.label')}</TableCell>
                <LeftBorderCell>{t(`ventilasjon.bruk.${varmepumpe.ventilasjon.bruk}`)}</LeftBorderCell>
              </TableRow>
            )}
            {varmepumpe.ventilasjon.varmesentral && (
              <TableRow>
                <TableCell>{t('kjel.varmesentral.label')}</TableCell>
                <LeftBorderCell>{t(`kjel.varmesentral.${varmepumpe.ventilasjon.varmesentral}`)}</LeftBorderCell>
              </TableRow>
            )}
            {varmepumpe.ventilasjon.serviceGjennomfortSiste2Ar && (
              <TableRow>
                <TableCell>{t('vannbaren.serviceGjennomfortSiste2Ar')}</TableCell>
                <LeftBorderCell>{t(`vannbaren.${varmepumpe.ventilasjon.serviceGjennomfortSiste2Ar}`)}</LeftBorderCell>
              </TableRow>
            )}
          </Fragment>
        )}
      </Fragment>
    )
  );
};
